module.exports = __webpack_public_path__ + "img/crm_banner2.0ff57b2a.png";